const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const maxPageButtons = 4;

  const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);

  const adjustedStartPage = Math.max(1, endPage - maxPageButtons + 1);

  for (let i = adjustedStartPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        <li
          className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
          style={{ color: currentPage === 1 ? "#6c757d" : "#007bff" }}
        >
          <a
            onClick={() => paginate(currentPage - 1)}
            className="page-link"
            href="#"
            style={{ color: currentPage === 1 ? "#6c757d" : "#007bff" }}
          >
            Previous
          </a>
        </li>
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${number === currentPage ? "active" : ""}`}
            style={{
              backgroundColor: number === currentPage ? "#007bff" : "#f8f9fa",
              color: number === currentPage ? "white" : "#007bff",
              borderColor: "#007bff",
            }}
          >
            <a
              onClick={() => paginate(number)}
              className="page-link"
              href="#"
              style={{
                backgroundColor: number === currentPage ? "#151365" : "white",
                borderColor: number === currentPage ? "#151365" : "white",
              }}
            >
              {number}
            </a>
          </li>
        ))}
        <li
          className={`page-item ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          style={{ color: currentPage === totalPages ? "#6c757d" : "#007bff" }}
        >
          <a
            onClick={() => paginate(currentPage + 1)}
            className="page-link"
            href="#"
            style={{
              color: currentPage === totalPages ? "#6c757d" : "#007bff",
            }}
          >
            Next
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
